import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonProgressIndicator } from './ProgressIndicator.definition';
import { chameleonLinearProgress } from '../LinearProgress/LinearProgress.definition';
import { chameleonTypography } from '../Typography/Typography.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonTypography({ prefix }), chameleonProgressIndicator({ prefix }), chameleonLinearProgress({ prefix }));
}
